export default "__VITE_ASSET__0f670495__"